import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { ShowInEpcotDirective } from '../../../lib/common/epcot-config.directive';
import { EpcotNotificationComponent } from '../../../lib/common/epcotNotifications/notification.component';
import BetslipAlertsModule from '../alerts/alerts.module';
import { LinearStakeErrorsService } from '../summary/services/linear/linear-stake-errors.service';
import BetslipValidationModule from './betslip-validation.module';
import LinearErrorsListComponent from './components/common/error-list/linear-errors-list.component';
import { ErrorsContainerComponent } from './components/common/errors-container.component';
import { LinearBetBuilderNotificationComponent } from './components/common/notifications/bet-builder/linear-bet-builder-notification.component';
import { LinearComboPreventionNotificationComponent } from './components/common/notifications/combo-prevention/linear-combo-prevention-notification.component';
import { LinearOddsChangeNotificationComponent } from './components/common/notifications/odds-change/linear-odds-change-notification.component';
import { LinearContainerErrorsComponent } from './components/linear/linear-container-errors.component';
import { LinearSlipErrorsComponent } from './components/linear/linear-slip-errors.component';
import { LinearSummaryErrorsComponent } from './components/linear/linear-summary-errors.component';
import { SummaryErrorsComponent } from './components/tabbed/summary-errors.component';
import { TabbedPickErrorsComponent } from './components/tabbed/tabbed-pick-errors.component';
import BetslipValidationEffects from './effects/betslip-validation-effects';
import DigitalAcceptChangesEffects from './effects/digital-accept-changes-effects';
import { DigitalBetslipValidationEffects } from './effects/digital-betslip-validation.effects';
import LinearDigitalAcceptChangesEffects from './effects/linear-digital-accept-changes-effects';
import { CONTEXT_BETSLIP_VALIDATORS, EDIT_BET_SLIP_VALIDATORS, PURE_BETSLIP_VALIDATORS } from './services/betslip-validation-injection-tokens';
import { BETSLIP_VALIDATION_COMPOSER_INJECTION_TOKEN } from './services/composition/betslip/betslip-validation-composers';
import { EditBetBetslipValidationComposerService } from './services/composition/betslip/composers/edit-bet/edit-bet-betslip-validation-composer.service';
import { BetslipDigitalDialogFullService } from './services/dialogs/digital/betslip-digital-dialog-full.service';
import { ErrorViewModelService } from './services/error-viewmodel.service';
import { CashOutFailedErrorMessageFormatter } from './services/formatting/message-formatters/cash-out-failed-error-message-formatter';
import { EditBetEarlyPayoutChangedMessageFormatter } from './services/formatting/message-formatters/edit-bet-early-payout-changed-message-formatter';
import { MESSAGE_FORMATTER_INJECTION_TOKEN } from './services/formatting/message-formatters/message-formatter';
import { NoBetbuilderSystemPreCheckErrorMessageFormatter } from './services/formatting/message-formatters/no-betbuilder-system-precheck-error-formatter';
import { UndoCashoutFailedErrorMessageFormatter } from './services/formatting/message-formatters/undo-cashout-failed-error-message-formatter';
import { EditBetEarlyPayoutChangedValidator } from './services/validators/betslip/edit-bet-early-payout-changed.validator';
import { InsufficientFundsValidator } from './services/validators/betslip/insufficient-funds.validator';
import { NoBetbuilderSystemValidator } from './services/validators/betslip/no-betbuilder-system.validator';
import { EditBetAddedStakeNotDividableValidatorService } from './services/validators/slip/edit-bet-added-stake-not-dividable-validator.service';

@NgModule({
    imports: [
        CommonModule,
        EffectsModule.forFeature([
            BetslipValidationEffects,
            DigitalAcceptChangesEffects,
            DigitalBetslipValidationEffects,
            LinearDigitalAcceptChangesEffects,
        ]),
        BetslipValidationModule,
        ShowInEpcotDirective,
        EpcotNotificationComponent,
        BetslipAlertsModule,
    ],
    declarations: [
        LinearContainerErrorsComponent,
        LinearSummaryErrorsComponent,
        LinearErrorsListComponent,
        LinearComboPreventionNotificationComponent,
        LinearOddsChangeNotificationComponent,
        LinearBetBuilderNotificationComponent,
        LinearSlipErrorsComponent,
        SummaryErrorsComponent,
        ErrorsContainerComponent,
        TabbedPickErrorsComponent,
    ],
    providers: [
        { provide: CONTEXT_BETSLIP_VALIDATORS, useClass: InsufficientFundsValidator, multi: true },
        { provide: PURE_BETSLIP_VALIDATORS, useClass: NoBetbuilderSystemValidator, multi: true },
        { provide: EDIT_BET_SLIP_VALIDATORS, useClass: EditBetEarlyPayoutChangedValidator, multi: true },
        { provide: EDIT_BET_SLIP_VALIDATORS, useClass: EditBetAddedStakeNotDividableValidatorService, multi: true },

        CashOutFailedErrorMessageFormatter,
        { provide: MESSAGE_FORMATTER_INJECTION_TOKEN, useClass: EditBetEarlyPayoutChangedMessageFormatter, multi: true },
        { provide: MESSAGE_FORMATTER_INJECTION_TOKEN, useClass: UndoCashoutFailedErrorMessageFormatter, multi: true },
        { provide: MESSAGE_FORMATTER_INJECTION_TOKEN, useClass: NoBetbuilderSystemPreCheckErrorMessageFormatter, multi: true },

        ErrorViewModelService,
        BetslipDigitalDialogFullService,
        LinearStakeErrorsService,
        { provide: BETSLIP_VALIDATION_COMPOSER_INJECTION_TOKEN, useClass: EditBetBetslipValidationComposerService, multi: true },
    ],
    exports: [
        ErrorsContainerComponent,
        LinearContainerErrorsComponent,
        LinearSummaryErrorsComponent,
        LinearSlipErrorsComponent,
        SummaryErrorsComponent,
        TabbedPickErrorsComponent,
        LinearErrorsListComponent,
    ],
})
export default class BetslipDigitalValidationModule {}
